/**
 * @generated SignedSource<<9d283a75a1c277f5afd6893955bb4a72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectInvoicingTable_company$data = {
  readonly currency: string | null;
  readonly newXeroEnabled: boolean | null;
  readonly quickbooksEnabled: boolean | null;
  readonly economicEnabled: boolean | null;
  readonly sageIntacctConnectionEnabled: boolean | null;
  readonly integrations: {
    readonly userCanUnlinkInvoice: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ExportInvoiceButton_company">;
  readonly " $fragmentType": "ProjectInvoicingTable_company";
};
export type ProjectInvoicingTable_company$key = {
  readonly " $data"?: ProjectInvoicingTable_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTable_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectInvoicingTable_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newXeroEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quickbooksEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "economicEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctConnectionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyIntegrationsType",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userCanUnlinkInvoice",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExportInvoiceButton_company"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "a8b87c1f351b6adc0272d66fc511ffc4";

export default node;
